import { BookingFlowStep } from '@/types/bookingFlow'

export interface BookingFlowLayoutStep extends BookingFlowStep {
  title: string
  path?: string
  completed?: boolean
}

export const steps: BookingFlowLayoutStep[] = [
  { number: 1, title: 'Shipping Options', data: {} },
  { number: 2, title: 'Traveler Details', data: {} },
  { number: 3, title: 'Additional Options & Payment Details', data: {} },
]
